export const CLASS_PROPERTY_SUFFIX = 'Class';
export const CLASSES_PROPERTY_SUFFIX = 'Classes';
export const TARGET_PROPERTY_SUFFIX = 'Target';
export const TARGETS_PROPERTY_SUFFIX = 'Targets';
export const VALUE_PROPERTY_SUFFIX = 'Value';
